import React from 'react'

import { ThemeProvider, theme } from '@octane/spark'


export const HintLabelText = ({
    hintLabelText,
}) => {
    return (
        <ThemeProvider theme={theme}>
            <div
               style={{
                   color: `${theme.colors.monochrome.graphite}`,
                   weight: 425,
                   display: "flex",
                   justifyContent: "right",
               }}
               className="spark-text-secondary spark-text-italic spark-text-12px"
               >
                  {hintLabelText}
            </div>
        </ThemeProvider>
    )
}
